import React from "react";

export const PlayIcon = () => {
    return (
        <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.5 7.06367C14.1667 7.44857 14.1667 8.41082 13.5 8.79572L1.5 15.7239C0.833332 16.1088 -6.83108e-07 15.6277 -6.49459e-07 14.8579L-4.37766e-08 1.00149C-1.01276e-08 0.231691 0.833333 -0.249434 1.5 0.135466L13.5 7.06367Z"
                fill="white"
            />
        </svg>
    );
};
